"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _constants = require("../utils/constants");

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes/CustomPropTypes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _busyIndicator = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/busy-indicator.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _busyIndicator.default);
/** A **Busy Indicator** informs the user of an ongoing operation. */

var BusyIndicator = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _context, _classnames;

  var className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      show = _ref.show,
      size = _ref.size,
      localizedText = _ref.localizedText,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "cssNamespace", "show", "size", "localizedText"]);
  var busyIndicatorClasses = classnames((_classnames = {}, (0, _defineProperty2.default)(_classnames, (0, _concat.default)(_context = "".concat(cssNamespace, "-busy-indicator--")).call(_context, size), size === 'm' || size === 'l'), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-busy-indicator"), size === 's'), _classnames), className);
  if (!show) return null;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    "aria-hidden": "false",
    "aria-label": localizedText.loading,
    className: busyIndicatorClasses,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-busy-indicator--circle-0"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-busy-indicator--circle-1"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-busy-indicator--circle-2"))
  }));
});

BusyIndicator.displayName = 'BusyIndicator';
process.env.NODE_ENV !== "production" ? BusyIndicator.propTypes = {
  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Localized text to be updated based on location/language */
  localizedText: _CustomPropTypes.default.i18n({
    /** aria-label for Busy Indicator component */
    loading: _propTypes.default.string
  }),

  /** Set to **true** to make Busy Indicator visible */
  show: _propTypes.default.bool,

  /** Size of the component: 's', 'm' or 'l' */
  size: _propTypes.default.oneOf(_constants.BUSY_INDICATOR_SIZES)
} : void 0;
BusyIndicator.defaultProps = {
  localizedText: {
    loading: 'Loading'
  },
  size: 'm',
  show: false
};

var _default = (0, _withStyles.default)(BusyIndicator);

exports.default = _default;